import React, { useEffect, useState } from "react";
import baseURL from "../../../../configs/api";
import { GridColDef } from "@mui/x-data-grid";
import AddNote from "./AddNote";
import { getCommentsReportByAttributeAndAttributeId } from "../../../../services/comment";
import { useTheme } from "../../../../components/hooks/useTheme";
import axois from "../../../../configs/axois";
import { CustomDataGrid } from "../../../../components/common/CustomDataGrid";
import colorConfigs from "../../../../configs/colorConfigs";
import DOMPurify from "dompurify";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";
import useGeneral from "../../../../components/hooks/useGeneral";
import moment from "moment";

type Props = {
    idNumber: string;
};

export default function CustomerNotes({ idNumber }: Props) {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { handleTenantError }: any = useTenant();
    const { dateFormat }: any = useGeneral();
    const [fullName, setFullName] = useState<string>("");
    const [tableData, setTableData] = useState<any[]>([]);
    const [isSaved, setIsSaved] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(true);
    const [addNotePopup, setAddNotePopup] =
        useState<boolean>(false);

    const columns: GridColDef[] = [
        {
            field: "notes",
            headerClassName: themeStyles.table.headerBg,
            headerName: "Notes Text",
            align: "left",
            editable: false,
            sortable: false,
            flex: 1,
            renderCell: (params) => (
                <div
                    className="whitespace-pre-wrap"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(params.value) }}
                />
            ),
        },
        {
            field: "createdDate",
            headerName: "Date",
            headerClassName: themeStyles.table.headerBg,
            editable: false,
            sortable: false,
            align: "left",
            flex: 1,

        },

    ];

    useEffect(() => {
        axois
            .get(`${baseURL}Customer/${idNumber}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setFullName(response.data.firstName + " " + response.data.lastName);
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber])

    useEffect(() => {
        if (isSaved) {
            setLoading(true);
            getCommentsReportByAttributeAndAttributeId("Customer", parseInt(idNumber), tenantId)
                .then(data => {
                    setTableData(() =>
                        data?.map((item: any) => {
                            return {
                                ...item,
                                notes: item?.notes,
                                createdDate: item.createdDate
                                    ? moment(new Date(item.createdDate)).format(dateFormat + "hh:mm a")
                                    : "",
                            }
                        })
                    );
                    setLoading(false);
                    setIsSaved(false);
                    handleTenantError(null);
                })
                .catch(error => {
                    setTableData([]);
                    setLoading(false);
                    setIsSaved(false);
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSaved]);

    return (
        <>
            <div className="w-full mt-2">
                <div className={`w-full pb-4`}>
                    <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                        <div className="flex items-center gap-1.5">
                            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Customer - {fullName}</h2>
                        </div>

                        <div className="flex items-center gap-1.5">

                            <button className={`px-[12px] py-[10px] ${colorConfigs.btn.main.tailwind} shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                onClick={() => setAddNotePopup(true)}
                            >
                                <span className="text-xs font-medium">Add Note</span>

                            </button>
                        </div>
                    </div>
                </div>
                <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>
                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Notes</h2>
                    </div>

                    <CustomDataGrid
                        filteredRows={tableData}
                        columns={columns}
                        loading={loading}
                    />
                </div>
            </div>

            <AddNote
                customerId={idNumber}
                addNotePopup={addNotePopup}
                setAddNotePopup={() => {
                    setAddNotePopup(false);
                    setIsSaved(true);
                }} />

        </>
    );
};